import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { PaginationResponse, ResponseData } from "./types/_public";
import { IPool } from "./types/_pool";
const api = new APIClient();

const path = '/secured/token';
const poolApi = {
  pools(pair: string, params: any): Promise<AxiosResponse<ResponseData<IPool[]> & PaginationResponse, any>> {
    const url = `${path}/pair/${pair}/detail`
    return api.get(url, params)
  },
  optionPools(params: any): Promise<AxiosResponse<ResponseData<IPool[]> & PaginationResponse, any>> {
    const url = `${path}/getArchivePair`
    return api.get(url, params)
  },
  postPool(dataForm: any): Promise<AxiosResponse<ResponseData<IPool>, any>> {
    const url = `/secured/wallet/createSplashPool`;
    return api.post(url, dataForm)
  },
  putPool(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IPool>, any>> {
    const url = `${path}/${id}`;
    return api.put(url, dataForm)
  },
  deletePool(id: string | number): Promise<AxiosResponse<ResponseData<IPool>, any>> {
    const url = `${path}/${id}`;
    return api.delete(url);
  },
}
export default poolApi
